const replaceShortCodes = html => {

  if (!html || html == '') { return '' }

  html = window.wp.shortcode.replace(
    'VAL',
    html,
    SC => (`
      <span 
        class="playmotiv-shortcode"
        data-tag="${SC.tag}"
        ${Object.keys(SC.attrs.named)
          .map(key => 'data-' + key + '="' + SC.attrs.named[key] + '"')
          .join(' ')
        }
      >
        ${SC.content || 'NO CONTENT'}
      </span>
    `)
  )
  
  html = window.wp.shortcode.replace(
    'JITSI',
    html,
    SC => {
      
      return `<div class="playmotiv-shortcode-jitsi" />`
    }
  )

  return html
}

export default replaceShortCodes
